import { Entry } from 'contentful'
import {
  IContentfulConfigurableResourceEntry,
  TContentfulConfigurableResource,
} from 'types/contentful/configurableResource.types'

export const parseConfigurableResource = (
  configurableResource: Entry<IContentfulConfigurableResourceEntry>
): TContentfulConfigurableResource => {
  const resource = {
    componentKey: 'configurableResource',
    name: configurableResource?.fields?.name,
    renderTo: configurableResource?.fields?.renderTo,
    resource: configurableResource?.fields?.resource,
  }
  return resource
}
